import type { DateTime } from '@ksyos/date-time';
import { Button } from '@ksyos/design-system';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { addAddendumTimeCheck } from '@common/utils/addAddendumTimeCheck';
import { getSelectedLanguage } from '@frontend/translate';
import { useInterval } from '@frontend/utils';

interface IAddendumButtonProps {
    dateSent?: DateTime;
    onAddAddendum: () => void;
    performerPractitionerId?: string;
    sx?: React.CSSProperties;
}

export function AddendumButton(props: IAddendumButtonProps) {
    const { onAddAddendum, dateSent, performerPractitionerId } = props;

    const currentPractitionerId = useSelector((state: IReduxState) => state.authentication.id);

    const translate = getSelectedLanguage();

    const [allowAddAddendum, setAllowAddAddendum] = useState(addAddendumTimeCheck(dateSent));

    useInterval(
        () => {
            setAllowAddAddendum(addAddendumTimeCheck(dateSent));
        },
        allowAddAddendum ? 1000 : null
    );

    if (!performerPractitionerId || performerPractitionerId !== currentPractitionerId) {
        return null;
    }

    return (
        <>
            {allowAddAddendum && (
                <Button
                    onClick={onAddAddendum}
                    sx={props.sx}
                    variant="outline"
                >
                    {translate.addendum.add}
                </Button>
            )}
        </>
    );
}
